// import Vue from 'vue'
import UnsubscribeAPI from '@/api/unsubscribe'
import {unsubscribe as mutations} from '../types/mutation-types'
import {unsubscribe as actions} from '../types/action-types'
import Unsubscribe from '../../models/UnsubscribeClass'
import Pagination from '../../models/PaginationClass'

export default {
  namespaced: true,
  state: {
    loading: false,
    postcode: null,
    collection: [],
    pagination: new Pagination({})
  },
  getters: {
    loading (state) {
      return state.loading
    },
    postcode (state) {
      return state.postcode
    },
    collection (state) {
      return state.collection
    },
    pagination (state) {
      return state.pagination
    }
  },
  mutations: {
    [mutations.UNSUBSCRIBE_REQUEST] (state) {
      state.loading = true
    },
    [mutations.UNSUBSCRIBE_SUCCESS] (state, unsubscribe) {
      state.loading = false
      if (unsubscribe) {
        state.collection = unsubscribe
      }
    },

    [mutations.ERROR] (state) {
      state.loading = false
      state.pagination = new Pagination({})
      state.collection = []
      state.postcode = null
    },

  },
  actions: {

    [actions.UNSUBSCRIBE_GET] ({commit}, params) {
      commit(mutations.UNSUBSCRIBE_REQUEST)
      return UnsubscribeAPI.getunsubscribe(params)
        .then(response => {
          commit(mutations.UNSUBSCRIBE_SUCCESS, [new Unsubscribe(response.data)])
          return response
        })
        .catch(error => {
          commit(mutations.ERROR)
          return Promise.reject(error)
        })
    },

    [actions.UNSUBSCRIBE_STORE] ({commit}, data) {
      commit(mutations.UNSUBSCRIBE_REQUEST)
      return UnsubscribeAPI.subscribeReceive(data)
        .then(response => {
          commit(mutations.UNSUBSCRIBE_SUCCESS, [new Unsubscribe(response.data)])
          return response
        })
        .catch(error => {
          commit(mutations.ERROR)
          return Promise.reject(error)
        })
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/unsubscribe.js